import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TariffFormComponent } from './tariff-form/tariff-form.component';
import { TariffPageComponent } from './tariff-page/tariff-page.component';
import { TariffsListComponent } from './tariffs-list/tariffs-list.component';
import { TariffService } from '@app/driver-tariffs/services/tariff.service';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencySelectComponent } from './currency-select/currency-select.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { RegularPaymentsComponent } from './regular-payments/regular-payments.component';
import { RegularPaymentsService } from './services/regular-payments.service';
import { CommissonBonusesComponent } from './commisson-bonuses/commisson-bonuses.component';
import { ScalesComponent } from './scales/scales.component';
import { NgxMaskModule } from 'ngx-mask';
import { ConvertTimeExpressionService } from '../shared/services/convert-time-expression.service';
import { SharedModule } from '@app/shared/shared.module';
import { DriverBonusesTabComponent } from './driver-bonuses-tab/driver-bonuses-tab.component';
import { ScheduledBonusesService } from './services/scheduled-bonuses.service';
import { NewDriverBonusesTabComponent } from './new-driver-bonuses-tab/new-driver-bonuses-tab.component';
import { NewDriverBonusesService } from './services/new-driver-bonuses.service';
import { CompensationTabComponent } from './compensation-tab/compensation-tab.component';
import { BrandingModule } from '../branding/branding.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    SharedModule,
    BrandingModule
  ],
  declarations: [
    TariffFormComponent,
    TariffPageComponent,
    TariffsListComponent,
    CurrencySelectComponent,
    DeleteDialogComponent,
    RegularPaymentsComponent,
    CommissonBonusesComponent,
    ScalesComponent,
    DriverBonusesTabComponent,
    NewDriverBonusesTabComponent,
    CompensationTabComponent
  ],
  providers: [
    TariffService,
    RegularPaymentsService,
    ConvertTimeExpressionService,
    ScheduledBonusesService,
    NewDriverBonusesService
  ],
  entryComponents: [DeleteDialogComponent]
})
export class DriverTariffsModule {}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/driver-tariffs.module.ts